import { objectToQueryParams } from 'utils/urlutils';
export const formatUrl = (context) => {
    let queryString = '';
    if (context.query) {
        queryString = objectToQueryParams(context.query, x => x.toString());
    }
    const { protocol, port, hostname, pathname } = context;
    const portComponent = port ? `:${port}` : '';
    return `${protocol}://${hostname}${portComponent}${pathname}${queryString}`;
};
